import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
interface HeroProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
  buttons?: Array<{
    label: string;
    href: string;
    variant?: 'primary' | 'secondary' | 'outline';
  }>;
  overlay?: boolean;
  height?: 'full' | 'large' | 'medium';
}
export function Hero({
  title,
  subtitle,
  backgroundImage,
  buttons = [],
  overlay = true,
  height = 'full'
}: HeroProps) {
  const heights = {
    full: 'min-h-screen',
    large: 'min-h-[80vh]',
    medium: 'min-h-[60vh]'
  };
  return <div className={`relative ${heights[height]} flex items-center justify-center`} data-id="element-79">
      {backgroundImage && <>
          <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: `url(${backgroundImage})`
      }} data-id="element-80" />
          {overlay && <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" data-id="element-81" />}
        </>}

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-82">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-white mb-6 text-balance font-bold" data-id="element-83">
          {title}
        </motion.h1>

        {subtitle && <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-lg md:text-xl text-white/95 mb-12 max-w-3xl mx-auto text-balance font-medium drop-shadow-lg" data-id="element-84">
            {subtitle}
          </motion.p>}

        {buttons.length > 0 && <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-wrap gap-4 justify-center" data-id="element-85">
            {buttons.map((button, index) => <Button key={index} variant={button.variant || 'primary'} size="lg" href={button.href} data-id="element-86">
                {button.label}
              </Button>)}
          </motion.div>}
      </div>
    </div>;
}